import { render, staticRenderFns } from "./ImageItem5.vue?vue&type=template&id=3204236c"
import script from "./ImageItem5.vue?vue&type=script&lang=js"
export * from "./ImageItem5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports